export const STATUS_META = {
  researching: { label: "Researching", cls: "text-slate-300 border-slate-400/40 bg-slate-400/10" },
  preparing: { label: "Preparing", cls: "text-amber-300 border-amber-400/40 bg-amber-400/10" },
  submitted: { label: "Submitted", cls: "text-[var(--aria-primary)] border-[var(--aria-primary)]/40 bg-[var(--aria-primary)]/10" },
  interview: { label: "Interview", cls: "text-[var(--aria-accent)] border-[var(--aria-accent)]/40 bg-[var(--aria-accent)]/10" },
  offer: { label: "Offer", cls: "text-emerald-300 border-emerald-400/40 bg-emerald-400/10" },
  accepted: { label: "Accepted", cls: "text-emerald-400 border-emerald-400/60 bg-emerald-400/15" },
  rejected: { label: "Rejected", cls: "text-red-400 border-red-400/40 bg-red-400/10" },
  withdrawn: { label: "Withdrawn", cls: "text-slate-500 border-slate-500/40 bg-slate-500/10" },
};
